import { render, staticRenderFns } from "./phy.vue?vue&type=template&id=7ffa3a3d&scoped=true&"
import script from "./phy.vue?vue&type=script&lang=ts&"
export * from "./phy.vue?vue&type=script&lang=ts&"
import style0 from "./phy.vue?vue&type=style&index=0&id=7ffa3a3d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ffa3a3d",
  null
  
)

export default component.exports